// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3tQJ_","colMaxWidth":"Table_colMaxWidth__2ZHcv"};